import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Label } from '@repo/videa-components';

export const NoteReviewWarning = () => {
  return (
    <Label htmlFor="clinical-note">
      <div className="vai-flex vai-items-start vai-rounded-md vai-px-2 vai-py-1 ai-text-sm vai-w-full">
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          className="vai-mr-2 vai-mt-0 vai-text-amber-500"
        />
        <p className="vai-text-black vai-font-light">
          Review your note before use to ensure it accurately represents the
          patient visit.
        </p>
      </div>
    </Label>
  );
};
